/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CurrencySelector_user$ref = any;
type CurrencySelector_viewer$ref = any;
type LinkColumnItem_viewer$ref = any;
export type FooterBottomRow_viewer$ref = any;
export type FooterBottomRow_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": CurrencySelector_user$ref;
    } | null;
    readonly " $fragmentRefs": LinkColumnItem_viewer$ref & CurrencySelector_viewer$ref;
    readonly " $refType": FooterBottomRow_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FooterBottomRow_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "CurrencySelector_user",
                            "args": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "LinkColumnItem_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CurrencySelector_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'f31e4bbb4368eafd7dbf784fc0a8580e';
export default node;
